import React, { useState, useEffect } from "react";

import { Paper, TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  ModalDeleteConfirm,
  Title,
  Loading,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  deleteById,
  getByFilter,
  headCells,
  RenderStatusVerifikasiBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";

import {
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_PENGAJUAN,
  STATUS_PENGERJAAN_REVISI,
} from "../HelpDesk/helpers";
import FormFilterDaftarRequest from "./FormFilter";
import { WMS_FA_INPUT_MAINTENANCE } from "App/constants";
import { FreezeTable } from "components/organism";

export default function DaftarMaintenance({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [reqID, setReqID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeMenu(WMS_FA_INPUT_MAINTENANCE);
      })
      .then(() => {
        changeParentData({
          id: row?.id,
          id_helpdesk_header: row?.id_helpdesk,
          unit_id: row?.unit_id,
          unit: isNull(row?.unit) ? "Pilih Unit" : row?.unit,
          gudang_id: row?.gudang_id,
          gudang: isNull(row?.gudang) ? "Pilih Gudang" : row?.gudang,
          remark: row?.remark,
          vendor_id: row?.vendor_id,
          vendor: isNull(row?.vendor) ? "Pilih Vendor" : row?.vendor,
          pic: row?.pic,
          user_request: row?.user_request,
          status_service: row?.status_service,
          type: "update",
          status: true,
          isOpenDraf:
            row?.status_request === STATUS_PENGERJAAN_DRAFT
              ? true
              : row?.status_request === STATUS_PENGERJAAN_REVISI
              ? true
              : false,
          isProcess:
            row?.status_request === STATUS_PENGERJAAN_DRAFT
              ? false
              : row?.status_request === STATUS_PENGERJAAN_REVISI
              ? false
              : true,
          tanggal_service: row?.tanggal_service,
        });
        changeTitle(WMS_FA_INPUT_MAINTENANCE);
        handleClickMenu({
          code: WMS_FA_INPUT_MAINTENANCE,
          name: "Input Maintenance",
        });
      });
  };

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilter(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setReqID(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deleteById(reqID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Maintenance"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarRequest
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarRequest
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

export const TableDaftarRequest = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  onlySelect = false,
  handleClickSelect,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const RenderAction = ({ row }) => {
    if (onlySelect) {
      if (row?.status_service === STATUS_PENGERJAAN_PENGAJUAN) {
        return (
          <>
            <IconButtonDatatable
              color='secondary'
              onClick={() => handleClickSelect(row)}>
              <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
            </IconButtonDatatable>
          </>
        );
      } else {
        return <></>;
      }
    } else {
      if (row?.status_service === STATUS_PENGERJAAN_DRAFT) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}>
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
            <IconButtonDatatable onClick={() => handleClickDelete(row)}>
              <TrashIcon />
            </IconButtonDatatable>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}>
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
          </div>
        );
      }
    }
  };

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}>
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope='row' padding='none' align='center'>
              {index + 1}
            </TableCell>

            <TableCell scope='row' padding='none' align='center'>
              <RenderAction row={row} />
            </TableCell>
            <TableCell align='left'>{row?.id}</TableCell>
            <TableCell align='left'>{row?.unit}</TableCell>
            <TableCell align='left'>{row?.gudang}</TableCell>
            <TableCell align='left'>
              {isNull(row?.id_helpdesk_header) ? "-" : row?.id_helpdesk_header}
            </TableCell>
            <TableCell align='left'>
              {isNull(row?.remark) ? null : row?.remark}
            </TableCell>
            <TableCell align='left'>{row?.user_request}</TableCell>
            <TableCell align='left'>
              {isNull(row?.vendor) ? "-" : row?.vendor}
            </TableCell>
            <TableCell align='left'>
              {isNull(row?.pic) ? "-" : row?.pic}
            </TableCell>
            <TableCell align='left'>
              <RenderStatusVerifikasiBadge status={row?.status_service} />
            </TableCell>
            <TableCell align='left'>
              {isNull(row?.tanggal_service)
                ? "-"
                : defaultDateDisplay(row?.tanggal_service)}
            </TableCell>
            <TableCell align='left'>
              {defaultDateDisplay(row?.createdAt)}
            </TableCell>
            <TableCell align='left'>{row?.createdBy}</TableCell>
            <TableCell align='left'>
              {defaultDateDisplay(row?.updatedAt)}
            </TableCell>
            <TableCell align='left'>{row?.updatedBy}</TableCell>
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align='center' colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
